import { RootState } from "../../redux/reducers";
import { store } from "../../redux/store";
import httpService from "../httpService";
import { C2BOrderCreateDto, C2BOrderDto, C2BOrderMetaOutDto, PayoutTransactionDto } from "../../models/marketplace.model";

export async function createOrders(createDtos: C2BOrderCreateDto[]): Promise<void> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .post<void>(`/marketplace/payments/${selectedDashboard}/c2b-orders`, createDtos)
        .then(() => { })
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getOrders(productId: string): Promise<C2BOrderDto[]> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<C2BOrderDto[]>(`/marketplace/payments/${selectedDashboard}/c2b-orders/product/${productId}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}




export async function deleteOrder(orderId: number): Promise<void> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .delete(`/marketplace/payments/${selectedDashboard}/c2b-orders/${orderId}`)
        .then(() => { })
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}


export async function getOrdersForUserMetadata(userId: number): Promise<C2BOrderMetaOutDto> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<C2BOrderMetaOutDto>(`/marketplace/payments/${selectedDashboard}/c2b-orders/user/${userId}/meta`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getOrdersForUser(dashboardMemberId: number): Promise<C2BOrderDto[]> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<C2BOrderDto[]>(`/marketplace/payments/${selectedDashboard}/c2b-orders/user/${dashboardMemberId}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getPayoutTransactionsForCommunity(): Promise<PayoutTransactionDto[]> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<PayoutTransactionDto[]>(`/marketplace/payments/${selectedDashboard}/payout-transactions`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getPayoutTransactionForCommunity(transactionId: string): Promise<PayoutTransactionDto[]> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<PayoutTransactionDto[]>(`/marketplace/payments/${selectedDashboard}/payout-transactions/${transactionId}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401 || err.response.status === 403) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getTicketUnitsOnEvent(eventId: number): Promise<C2BOrderDto[]> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<C2BOrderDto[]>(`/marketplace/payments/${selectedDashboard}/event/${eventId}/ticket-units`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}